
<template>
    <Card>
        <template slot="title">
            <Breadcrumb>
                <BreadcrumbItem to="/spuInfo">SPU信息</BreadcrumbItem>
                <BreadcrumbItem>{{pageType==1?"编辑SPU":"添加SPU"}}</BreadcrumbItem>
            </Breadcrumb>
        </template>
        <router-link to="/spuInfo" slot="extra">返回列表</router-link>
         <Form 
         :style="{width:'400px'}"
         ref="formValidate" 
         :model="formValidate" 
         :rules="ruleValidate" 
         :label-width="80">
            <FormItem label="名称" prop="name">
                    <Input v-model="formValidate.name" placeholder="请输入名称"/>
            </FormItem>
            <FormItem>
                <span ref="brick" class="public-require" slot="label">所属分类</span>
                <Treeselect 
                    v-model="formValidate.categoryCode" 
                    :data="selectData"
                    text-field-name="name"
                    value-field-name="code"
                    size="small"
                    placeholder="全部分类"
                ></Treeselect>
            </FormItem>
            <FormItem label="品牌" prop="brandCode">
                <Select v-model="formValidate.brandCode" placeholder="请选择品牌">
                    <Option v-for="(item,index) in brandList" :key="index" :value="item.code">{{item.name}}</Option>
                </Select>
            </FormItem>
            <FormItem label="是否陈列" prop="checkFlag">
                <Select v-model="formValidate.checkFlag" placeholder="请选择是否陈列">
                    <Option value="0">不巡检</Option>
                    <Option value="1">需要门店上传巡检</Option>
                </Select>
            </FormItem>
            <FormItem>
                <span slot="label" class="public-require">排序</span>
                <Input type="text" v-model="formValidate.sortIndex" placeholder="请输入排序"/>
            </FormItem>
            <FormItem label="状态" prop="status">
                <i-switch v-model="formValidate.status" true-value="0" false-value="1"></i-switch>
            </FormItem>
            <FormItem label="标签">
                <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                    <Checkbox
                        :indeterminate="indeterminate"
                        :value="checkAll"
                        @click.prevent.native="handleCheckAll">全选</Checkbox>
                </div>
                <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
                    <Checkbox 
                    v-for="(item,i) in labelList" 
                    :label="item.name" 
                    :key="i"
                    ></Checkbox>
                </CheckboxGroup>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
                <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
            </FormItem>
        </Form>
    </Card>
</template>
<script>
  import Treeselect from 'vue-treeselect';
    export default {
    components:{
        Treeselect
    },
        data () {
            return {
                code:'',
                pageType:0,
                selectData:[],
                brandList:[],
                labelList:[],
                formValidate:{
                    name:'',
                    categoryCode:'',
                    brandCode:'',
                    status: '1',
                    checkFlag:'',
                    sortIndex:''
                },
                ruleValidate: {
                    name: [
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    brandCode: [
                        { required: true, message: '请选择品牌', trigger: 'blur' }
                    ],
                    checkFlag: [
                        { required: true, message: '请选择是否陈列', trigger: 'blur' }
                    ],
                    status: [
                        { required: true }
                    ],
                },
                indeterminate: false,
                checkAll: false,
                checkAllGroup: []
            }
        },
        created(){
            this.getTree();
            this.getBrand();
            this.getLabel();
            this.getCode();
        },
        watch:{
            // tree选择后收起选项
            'formValidate.categoryCode'(a,b){
                this.$refs.brick.click();
            },
            deep:true
        },
        methods:{
            getCode(){
                let q = this.$route.query;
                if(q.code){
                    let code = q.code;
                    this.code = code;
                    this.pageType=1;
                    this.$api.spuDetail({code}).then((res) => {
                        if(res.code == '200'){
                            let d = res.data;
                            Object.keys(this.formValidate).forEach((key) => {
                                this.formValidate[key] = d[key];
                            });
                            let list = d.labelCodeList;
                            let fullList = this.labelList;
                            let array = [];
                            fullList.forEach(item=>{
                                let n = item.code;
                                if(list.indexOf(n)>-1){array.push(item.name)};
                            });
                            this.checkAllGroupChange(list);// 控制标签全选按钮状态
                            this.checkAllGroup = array;
                        }
                    });
                }
            },
            // 全部标签
            getLabel(){
                this.$api.labelSearch({}).then((res) => {
                    if(res.code == '200'){
                        let list = res.data;
                        if (!list || list.length == 0) {
                            this.labelList = [];
                            return
                        }
                        this.labelList = list;
                    }
                });
            },
            // 全部分类
            getTree(){
                this.$api['categoryAll']({}).then((res) => {
                    if (res.code == '200') {
                    let selectSt = {
                        name:'全部分类',
                        code:'',
                        opened:false,
                        parentCode:'-1'
                    }
                    let list = [];
                    if(res.data && res.data.length>0){
                        list = [...res.data,selectSt];
                    }
                    this.selectData = this.tools.arrayToTree(list,1);
                    }
                })
            },
            // 全部品牌
            getBrand(){
                this.$api.brandAll({}).then((res) => {
                    if(res.code == '200'){
                        let list = res.data;
                        if (!list || list.length == 0) {
                            this.brandList = [];
                            return
                        }
                        this.brandList = list;
                    }
                });
            },
            handleCheckAll () {
                let list = [...this.labelList];
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;
                if (this.checkAll) {
                    this.checkAllGroup = list.map(item=>{
                        return item.name;
                    });
                } else {
                    this.checkAllGroup = [];
                }
            },
            checkAllGroupChange (data) {
                let list = [...this.labelList];
                if (data.length === list.length) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
            handleSubmit (name) {
                let d = this.formValidate;
                let list = this.checkAllGroup;
                let fullList = this.labelList;
                let array = [];
                fullList.forEach(item=>{
                    let n = item.name;
                    if(list.indexOf(n)>-1){array.push(item.code)};
                });
                let data = {
                    ...d,
                    labelCodeList: array,
                    addOptUser:window.sessionStorage.getItem('name'),
                };
                const reg = new RegExp('^[0-9]*$');
                if (!data.sortIndex || !reg.test(data.sortIndex)) {
                    this.$Message.error('排序请输入数字');
                    return;
                }
                let path = 'spuAdd';
                if(this.pageType==1){
                    path = 'spuUpdate';
                    data.code = this.code;
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$api[path](data).then((res) => {
                            if(res.code == '200'){
                                this.$Message.success('操作成功');
                                this.$router.replace({ name: 'spuInfo'})
                            }
                        });
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/commodity/spuEdit.vue